'use client';
import { StyledBlogDetailsWrappper } from '@/components/common/ygen/sections/blog-details/blogdetaislwrapper.style';
import { StyledBlogDetails } from '@/components/common/ygen/sections/blog-details/blogdetails.style';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useRouter } from 'next/navigation';
import SocialShare from '@/components/common/ui/social/SocialShare';
import InnerBannerDetailsSub from '@/components/common/ygen/sections/inner-banner-details-sub/InnerBannerDetailsSub';
import Descriptions from '@/components/common/ui/details/Descriptions';
import Industry from '@/components/common/ygen/sections/industry/Industry';
import Modal from 'react-bootstrap/Modal';
import Quote from '@/components/common/ygen/sections/quote/Quote';
import ButtonNormal from '@/components/common/ui/buttons/ButtonNormal';
import DetailsSlider from '@/components/common/ui/details/DetailsSlider';
import {
	CURSOR_HIDE,
	CURSOR_SHOW,
	CURSOR_TEXT,
	DispatchCursor,
} from 'haspr-cursor';
import PartnerProgress from '@/components/common/ygen/sections/partner_progress/partner_progress';

const BlogDetails = ({ data, solution, industry }) => {
	const router = useRouter();


	// Memoize the arrow icon to prevent unnecessary re-renders
	const arrowIcon = useMemo(
		() => (
			<svg
				width="6"
				height="10"
				viewBox="0 0 6 10"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M5 1L1 5L5 9"
					stroke="#BB9753"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		[],
	);

	// Memoize the handleBack function to prevent unnecessary re-renders
	const handleBack = useCallback(() => {
		router.back();
	}, [router]);

	// Memoize the formatDate function to prevent unnecessary re-renders
	const formatDate = useCallback(dateString => {
		const months = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];

		if (!dateString) return { day: '', month: '', year: '' };

		const dateObj = new Date(dateString);
		return {
			day: dateObj.getDate(),
			month: months[dateObj.getMonth()],
			year: dateObj.getFullYear(),
		};
	}, []);

	// Memoize the date object to prevent unnecessary re-renders
	const { day, month, year } = useMemo(
		() => formatDate(data?.data?.date),
		[data?.data?.date, formatDate],
	);

	// Memoize the banner image to prevent unnecessary re-renders
	const bannerImage = useMemo(
		() => data?.images?.list?.find(f => f?.banner === 'on'),
		[data?.images?.list],
	);

	const bannerVideo = data?.images?.list?.find(f => f?.is_video === 'on');
	// Memoize the sections list to prevent unnecessary re-renders
	const sections_list = useMemo(() => data?.sections, [data?.sections]);

	const [modalIsOpen, setModalIsOpen] = useState(false);

	// Memoize the handleModalOpen function to prevent unnecessary re-renders
	const handleModalOpen = useCallback(e => {
		e.preventDefault();
		window.history.pushState(null, '', '#get-a-quote-product');
		setModalIsOpen(true);
	}, []);

	// Memoize the handleModalClose function to prevent unnecessary re-renders
	const handleModalClose = useCallback(() => {
		setModalIsOpen(false);
		window.location.hash = '';
	}, []);

	useEffect(() => {
		if (window.location.hash === '#get-a-quote-product') {
			setModalIsOpen(true);
		}
	}, []);

	return (
		<StyledBlogDetailsWrappper>
			<InnerBannerDetailsSub
				solution={solution || false}
				inidustry={industry || false}
				title={data?.page_data?.title}
				short_desc={data?.page_data?.short_desc}
				image={bannerImage?.full_path}
				video={bannerVideo?.full_path}
			/>
			<StyledBlogDetails className="blog_details" data-scroll-section>
				<Container>
					<Row>
						<Col md={8} className="blog_details__right">
							{sections_list?.length > 0 &&
								sections_list.map((item, index) => {
									switch (item?.section_data?.template) {
										case 'description':
											return (
												<Descriptions
													data={item}
													key={index}
												/>
											);
										case 'details_slider':
											return (
												<DetailsSlider
													data={item}
													key={index}
												/>
											);
										default:
											return null;
									}
								})}
						</Col>
						<Col
							md={{ span: 3, offset: 1 }}
							className="blog_details__left"
							id="blog_details">
							<div
								className="content-wrapper"
								data-scroll
								data-scroll-sticky
								data-scroll-offset="-200, 100"
								data-scroll-target="#blog_details">
								<SocialShare />
								{solution && (
									<ButtonNormal
										hoverBackground="#152637"
										text="View Products"
										margin="30px 0 0"
										src="/products"
										background="transparent"
										pathColor="white"
										color="#DD223F"
									/>
								)}
								<ButtonNormal
									hoverBackground="#152637"
									text="Request a Quote"
									margin="30px 0 0"
									src="#get-a-quote-product"
									onClick={handleModalOpen}
									background="#DD223F"
									pathColor="white"
									color="#FFFFFF"
								/>

								<ButtonNormal
									hoverBackground="#152637"
									text="Request a Demo"
									margin="30px 0 0"
									src="#get-a-quote-product"
									onClick={handleModalOpen}
									background="#DD223F"
									pathColor="white"
									color="#FFFFFF"
								/>
							</div>
						</Col>
					</Row>
				</Container>
			</StyledBlogDetails>
			{sections_list?.length > 0 &&
				sections_list.map((item, index) => {
					switch (item?.section_data?.template) {
						case 'partner_progress':
							return <PartnerProgress data={item} key={index} />;
						default:
							return null;
					}
				})}
			{!solution && (
				<Industry version={3} color="#152637" mainIndex={0} />
			)}
			<Modal
				interest={data?.page_data?.title}
				className="modal-video"
				show={modalIsOpen}
				onHide={handleModalClose}>
				<Modal.Body className="video">
					<Quote
						interest={data?.page_data?.title}
						onclick={handleModalClose}
					/>
				</Modal.Body>
			</Modal>
		</StyledBlogDetailsWrappper>
	);
};

export default React.memo(BlogDetails);
